import { AnimatePresence, motion } from 'framer-motion';
import React, { useState } from 'react';

import { Box, Center, Flex, IconButton, Image, Text } from '@vimeo/bokeh';
import { ChevronDown, Play } from '@vimeo/bokeh-icons';
import { Video } from '@vimeo/gctl-api/models/components/schemas/video/Video';

import { TextDecoration } from '../../types';
import { idFromUri } from '../../utils';

const DEFAULT_THUMBNAIL_IMAGE = 'https://i.vimeocdn.com/video/default_295x166.jpg';

type CommentClipPreviewProps = {
  setPreviewClip: (clipDetails: Video) => void;
  textDecoration: TextDecoration;
};

const CommentClipPreview = ({ textDecoration, setPreviewClip }: CommentClipPreviewProps) => {
  const clipDetails = textDecoration.assets?.video;

  const [showPreview, setShowPreview] = useState(true);

  if (!clipDetails || !idFromUri(clipDetails.uri)) return null;

  return (
    <Box>
      <Flex py="4px">
        <Text overflow="hidden" variant="body-md">{`"${clipDetails.name}"`}</Text>
        <IconButton
          px="4px"
          ml="4px"
          size="xs"
          variant="tertiary"
          aria-label="show-preview"
          onClick={() => setShowPreview(!showPreview)}
          icon={
            <ChevronDown
              transform={`rotate(${showPreview ? 0 : -90}deg)`}
              transition="transform 0.3s ease"
            />
          }
        />
      </Flex>
      <AnimatePresence>
        {showPreview && (
          <Flex
            position="relative"
            as={motion.div}
            direction="column"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto', transition: { type: 'tween' } }}
            exit={{ opacity: 0, height: 0 }}
            onClick={() => {
              setPreviewClip(clipDetails);
            }}
          >
            <Image
              src={clipDetails.pictures?.sizes?.[1]?.link}
              fallbackSrc={DEFAULT_THUMBNAIL_IMAGE}
              alt="comment video link thumbnail"
            />
            <Center height="100%" width="100%" position="absolute">
              <IconButton aria-label="preview-play" background="gray.50" icon={<Play />} />
            </Center>
          </Flex>
        )}
      </AnimatePresence>
    </Box>
  );
};

type CommentClipPreviewsProps = {
  setPreviewClip: (clipDetails: Video) => void;
  textDecorations: TextDecoration[];
};
export const CommentClipPreviews = ({
  setPreviewClip,
  textDecorations,
}: CommentClipPreviewsProps) => {
  return (
    <>
      {textDecorations.map((textDecoration, index) => {
        return (
          <CommentClipPreview
            key={index}
            textDecoration={textDecoration}
            setPreviewClip={setPreviewClip}
          />
        );
      })}
    </>
  );
};
